export function pxToRem(px: number | string) {
  if (typeof px === 'string') {
    px = Number(px.replace(/px/gi, ''));
  }

  return Math.round(((px / parseFloat(getComputedStyle(document.documentElement).fontSize) + Number.EPSILON) * 100) / 100);
}
